export default {
  loading: null,
  error: null
};
